module.exports = __webpack_public_path__ + "static/media/kiwi_vector_black.53193666.png";